<template>
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1749_33069)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.585 21.4736C11.2988 21.297 11.0021 21.138 10.6965 20.9976C9.93294 20.6445 8.91419 20.3122 7.81315 20.3122C6.48086 20.3122 5.27357 20.7997 4.50065 21.2101C4.25671 21.3378 3.98481 21.4028 3.70947 21.3992C3.43414 21.3955 3.16405 21.3234 2.92357 21.1893C2.67101 21.0531 2.45977 20.8514 2.31204 20.6055C2.1643 20.3595 2.08553 20.0783 2.08398 19.7913V6.77051C2.08398 6.12363 2.39128 5.45488 3.0194 5.07363C3.82565 4.58405 5.64023 3.64551 7.81315 3.64551C9.46003 3.64551 11.0892 4.17676 12.5007 5.01009C13.9121 4.17676 15.5413 3.64551 17.1882 3.64551C19.3611 3.64551 21.1757 4.58301 21.9819 5.07363C22.61 5.45488 22.9173 6.12363 22.9173 6.77051V19.7913C22.9173 20.4507 22.5225 20.9434 22.0777 21.1893C21.8371 21.3236 21.5668 21.3958 21.2913 21.3994C21.0158 21.4031 20.7437 21.338 20.4996 21.2101C19.7277 20.7997 18.5204 20.3122 17.1882 20.3122C16.0871 20.3122 15.0684 20.6455 14.3048 20.9976C13.9992 21.138 13.7025 21.297 13.4163 21.4736C13.1204 21.658 12.8704 21.8747 12.5017 21.8747C12.1309 21.8747 11.8819 21.658 11.585 21.4736ZM4.16732 19.0559V6.81426C4.86836 6.39759 6.25065 5.72884 7.81315 5.72884C9.0944 5.72884 10.3632 6.16426 11.459 6.81426V19.0559C10.5371 18.6434 9.25794 18.2288 7.81315 18.2288C6.37461 18.2288 5.09544 18.6403 4.16732 19.0559ZM13.5423 19.0559C14.4642 18.6434 15.7434 18.2288 17.1882 18.2288C18.6267 18.2288 19.9059 18.6403 20.834 19.0559V6.81426C20.1329 6.39759 18.7507 5.72884 17.1882 5.72884C15.9069 5.72884 14.6382 6.16426 13.5423 6.81426V19.0559Z"
        fill="#444444"
      />
    </g>
    <defs>
      <clipPath id="clip0_1749_33069">
        <rect width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
  export default {
    name: "plans",
    props: [],
    data: () => ({}),
    mounted() {},
    methods: {},
  };
</script>
